export default "__VITE_ASSET__beea89e3__"